<template>
  <div class="news">
    <div class="list">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: "news-list",
  props: {
    text: {
      type: String,
      default: " "
    }
  }
};
</script>

<style lang="less" scoped>
.news {
  .list {
    padding: 17px;
    font-size: 16px;
    color: #333333;
    border-bottom: 2px solid #eeeeee;
  }
}
.news:hover {
  .list {
    color: #17bbc5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/news-list.vue